var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"filters__no-results text-center"},[_c('span',{staticClass:"icon icon-no_results"}),_vm._v(" "),_c('p',[_vm._v("\n    "+_vm._s(_vm.stateInfo)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16a5c3fa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/packs/shared/components/empty_state.vue
// module id = 661
// module chunks = 0 1 2 3 4 5 6 7 8 10 15 19 32 355